<template>
  <div class="small">
    <line-chart :styles="baseStyles" :chart-data="datacollection"></line-chart>
  </div>
</template>

<script>
import LineChart from "@/components/charts/LineChart";

export default {
  components: {
    LineChart
  },
  props: {
    label: {
      required: true
    }
  },
  data() {
    return {
      datacollection: {
        datasets: [
          {
            label: this.label,
            data: [
              {
                t: new Date(2018, 10, 25),
                y: Math.floor(Math.random() * 100000) + 1
              },
              {
                t: this.randomDate(
                  new Date(2019, 1, 25),
                  new Date(2019, 3, 25),
                  8,
                  12,
                ),
                y: Math.floor(Math.random() * 100000) + 1
              },
              {
                t: this.randomDate(
                  new Date(2019, 3, 25),
                  new Date(2019, 5, 25),
                  8,
                  12,
                ),
                y: Math.floor(Math.random() * 100000) + 1
              },
              {
                t: this.randomDate(
                  new Date(2019, 5, 25),
                  new Date(2019, 7, 25),
                  8,
                  12,
                ),
                y: Math.floor(Math.random() * 100000) + 1
              },
              {
                t: this.randomDate(
                  new Date(2019, 7, 25),
                  new Date(2019, 9, 25),
                  8,
                  12,
                ),
                y: Math.floor(Math.random() * 100000) + 1
              },
              {
                t: this.randomDate(
                  new Date(2019, 9, 25),
                  new Date(2019, 11, 25),
                  8,
                  12,
                ),
                y: 36224
              }
            ],
            backgroundColor: "#3670ce",
            borderColor: "#3670ce",
            borderWidth: 1,
            lineTension: 0.15,
            pointHoverBackgroundColor: "#3670ce"
          }
        ]
      }
    };
  },
  methods: {
    randomDate(start, end, startHour, endHour) {
      const date = new Date(+start + Math.random() * (end - start));
      const hour = (startHour + Math.random() * (endHour - startHour));
      date.setHours(hour);
      return date;
    }
  },
  computed: {
    baseStyles() {
      return {
        height: `200px`,
        position: "relative"
      };
    }
  }
};
</script>

<style>
.small {
  position: relative;
  width: 100%;
}
</style>
